export default __webpack_public_path__ + "static/media/icon-deleted.cdf7b339.svg";